<template>
    <div>
        <b-modal v-model="mostrarModal" @show="iniciarForm()">
            <div slot="modal-title">Relatório Resumido de Despesas Gerais</div>
            <b-row>
                <b-col sm="12">
                    <b-form-group>
                        <label>Fornecedor</label>

                        <b-form-select taggable
                            :plain="true"
                            :options="fornecedores"
                            text-field="razaoSocial"
                            value-field="cpfCnpj"
                            v-model="fornecedor"
                        ></b-form-select>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col sm="12" md="6">
                    <b-form-group>
                        <label>Data da Despesa (DE)</label>
                        <date-picker
                            v-model="dataCadastroDe"
                            :config="$datePickerOptions2"
                            v-mask="'##/##/####'"
                        ></date-picker>
                    </b-form-group>
                </b-col>
                <b-col sm="12" md="6">
                    <b-form-group>
                        <label>Data da Despesa (ATÉ)</label>
                        <date-picker
                            v-model="dataCadastroAte"
                            :config="$datePickerOptions2"
                            v-mask="'##/##/####'"
                        ></date-picker>
                    </b-form-group>
                </b-col>
            </b-row>
            <div slot="modal-footer">
                <b-button
                    variant="secondary"
                    @click.stop="fechar()"
                    class="mr-2"
                    >Cancelar</b-button
                >
                <b-button
                    variant="primary"
                    @click.stop="filtrar()"
                    >Emitir Relatório</b-button
                >
            </div>
        </b-modal>
    </div>
</template>

<script>
    import download from '../../../../../shared/download';
    import AvaliacoesServicos from './../../AvaliacoesServicos'
    
    export default {
    data() {
        return {
            mostrarModal: false,
            fornecedores: [],
            fornecedor: null,
            dataCadastroDe: null,
            dataCadastroAte: null

        }
    },

    methods: {
        iniciarForm() {
            this.$store.dispatch('addRequest')
            AvaliacoesServicos.obterOpcoesFiltros().then((response) => {
                if (response) {
                    if (response.success) {
                        this.fornecedores = response.data.fornecedores
                        this.fornecedores.unshift({
                            razaoSocial: 'TODOS',
                            cpfCnpj: null
                        })
                    } else {
                        this.$toast.error(
                            'Erro ao obter opções dos filtros',
                            'ERROR',
                            this.$toastConfig.error
                        )
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },

        abrir() {
            this.mostrarModal = true
        },

        fechar() {
            this.mostrarModal = false
        },

        filtrar() {
            let filtroDto = {}
            if (this.fornecedor != -1) {
                filtroDto.fornecedor = this.fornecedor
            }

            if (this.dataCadastroDe) {
                filtroDto.dataCadastroDe = this.$moment(
                    this.dataCadastroDe,
                    'DD/MM/YYYY'
                ).format('YYYY-MM-DD')
            }

            if (this.dataCadastroAte) {
                filtroDto.dataCadastroAte = this.$moment(
                    this.dataCadastroAte,
                    'DD/MM/YYYY'
                ).format('YYYY-MM-DD')
            }
            this.obterRelatorio(filtroDto);
            //this.$emit('filtrar', {tipoRelatotio: this.tipoRelatorio ,filtroDto })
        },

        obterRelatorio(filtroRelatorioResumido) {
            this.$store.dispatch('addRequest')
            const filtro = filtroRelatorioResumido || {};
            AvaliacoesServicos.obterRelatorioDespesas('resumido',filtro).then(
                (response) => {
                    if (response) {
                        if (response.type === 'application/json') {
                            this.$toast.error(
                                'Falha ao obter relatório',
                                'ERROR',
                                this.$toastConfig.error
                            )
                        } else {
                            download(
                                response,
                                `Relatorio_Resumido_Avaliacoes_Despesas.xlsx`
                            )
                        }
                    }
                    this.$store.dispatch('removeRequest')
                    this.fechar()
                }
            )
        }
    }
}
</script>
